import { Context } from "@nuxt/types";
import { checkLang } from "~/helpers/configuration-utils";

// eslint-disable-next-line func-names
export default async function (context: Context) {
  const config = context.app.$vsf.$sapcc.config.baseStoreConfiguration;
  await checkLang(context, config);
}
